import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavigate = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button
            onClick={() => handleNavigate('/')}
            className="flex-shrink-0 cursor-pointer"
          >
            <img
              src="https://public.readdy.ai/ai/img_res/edc37492-aad1-484e-85c4-18ddf97f686d.png"
              alt="ChronoCharm"
              className="h-12 w-auto"
            />
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => handleNavigate('/')}
              className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              ホーム
            </button>
            <button
              onClick={() => handleNavigate('/guide')}
              className="px-6 py-2.5 bg-amber-600 text-white text-sm font-medium rounded-md hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              高級腕時計ガイド
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-900 cursor-pointer"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <button
              onClick={() => handleNavigate('/')}
              className="block w-full text-left text-gray-900 hover:text-amber-600 font-medium cursor-pointer"
            >
              ホーム
            </button>
            <button
              onClick={() => handleNavigate('/guide')}
              className="block w-full text-left px-6 py-2.5 bg-amber-600 text-white font-medium rounded-md hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              高級腕時計ガイド
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
